// extracted by mini-css-extract-plugin
export default {"activtyPage_container":"PortalActivityPage_activtyPage_container__2XeV0"};